import React, { memo, useState } from "react";
import userimg from "../../assets/images/avatar.svg";
import msgimg from "../../assets/images/msg.svg";
import Loader from "components/Loader";
import usePilotAvailableJobs from "hooks/usePilotAvailableJobs";
import { Link } from "react-router-dom";
import { getFormattedDate } from "utils";
import BidNowForm from "components/Modals/FormPopup/BidNowForm";
import useCurrentUser from "hooks/useCurrentUser";

const AvailableJobsPreview = ({ pilotRadius }) => {

  const payload = {
    skip: 0,
    limit: 2
  }
  const { jobsData, isLoading } = usePilotAvailableJobs(payload, pilotRadius);
  const { totalAvailableJobs, availableJobs } = jobsData;
  const [bidNowModal, setBidNowModal] = useState(false);
  const [selectedJobId, setSelectedJobId] = useState(null);
  const { user } = useCurrentUser();

  const handleShow = (id) => {
    setBidNowModal(true);
    setSelectedJobId(id)
  }

  const handleClose = () => {
    setBidNowModal(false);
  }

  return (
    <>
      {totalAvailableJobs > 0 && (
        <div>
          <Loader loading={isLoading} />
          <div className="d-flex job-card-home justify-content-between">
            <div className="heading-job-cards d-flex gap-2">
              <h4>Available Jobs</h4>
              <div className="bedge-green">
                <span>{totalAvailableJobs}</span>
              </div>
            </div>

            <Link to="/available-jobs" className="text-blue">
              View All
            </Link>
          </div>
          <div className="job-card-home">
            {availableJobs?.length > 0 && availableJobs?.map((job, idx) => {
              return (
                <div className="job-card" key={job?._id}>
                  <div className="d-flex align-items-center gap-2">
                    <img
                      alt="avatar"
                      src={`${user?.baseS3Url}${job?.clientId?.avatar}`}
                      className="round-img border border-secondary"
                      onError={(e) => {
                        e.currentTarget.onerror = null; // prevent infinite loop if fallback also fails
                        e.currentTarget.src = userimg;
                      }}
                    />
                    <p className="mb-0 dark-textss">{job?.clientId?.fullName}</p>
                  </div>
                  <h3>{job?.title}</h3>
                  <Link to={`/my-jobs/${job?._id}`}>
                    <p className="light-texts">Destination</p>
                    <address className="dark-textss">
                      {job?.address}
                    </address>
                    <div className="row">
                      <div className="col-lg-6">
                        <div>
                          <p className="light-texts">Required Date</p>
                          <p className="dark-textss">{getFormattedDate(job?.requiredDate)}</p>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div>
                          <p className="light-texts">Area Size ({job?.areaUnit?.toLowerCase()})</p>
                          <p className="dark-textss">{job?.areaSize}</p>
                        </div>
                      </div>
                    </div>
                  </Link>
                  <div className="d-flex gap-2 justify-content-between">
                    <Link to={`/my-jobs/${job?._id}`} className="btn white-btn">
                      Review Job
                    </Link>
                    <button onClick={() => handleShow(job?._id)} className="btn blue-btn">
                      Bid Now
                    </button>
                  </div>
                  <div className="msg-v">
                    <img alt="chat" src={msgimg} />
                  </div>
                </div>
              )
            })}
          </div>
          <BidNowForm
            show={bidNowModal}
            handleClose={handleClose}
            selectedJobId={selectedJobId}
          />
        </div>
      )}
    </>
  );
};

export default memo(AvailableJobsPreview);
